import React from "react"
import "./PrintBillDesk.scss"

import Table from "react-bootstrap/esm/Table"
import moment from "moment"
import { calculateAge } from "core/utils/date"

function PrintAP({ documentTitle, printRef, invoice, invoiceHistory, patient }: any) {
  //const [invoice, setInvoice] = useState<any>()

  const receiptDetails = invoiceHistory?.advanceHistory?.find(
    (ele: any) => ele?.mocReceiptId === documentTitle
  )

  return (
    <>

      <div className="printApWrapper" id="printId" ref={printRef}>
        <div className="Heading">CCCPL</div>

        <div className="patient-details">
          <div>
            <div className="patient-info">
              <div className="subHeading">Patient Name:</div>
              <div className="subHeading2">{invoice?.patientName}</div>
            </div>
            <div className="patient-info">
              <div className="subHeading">Patient ID:</div>
              <div className="subHeading2">{invoice?.mocPatientId}</div>
            </div>

            <div className="patient-info">
              <div className="subHeading">Invoice ID:</div>
              <div className="subHeading2">{invoice?.mocInvoiceId}</div>
            </div>
            <div className="patient-info">
              <div className="subHeading">Age:</div>
              <div className="subHeading2">{calculateAge(patient?.dob)}</div>
            </div>
            <div className="patient-info">
              <div className="subHeading">Gender:</div>
              <div className="subHeading2">{invoice?.gender}</div>
            </div>
            <div className="patient-info">
              <div className="subHeading">Primary Consultant: </div>
              <div className="subHeading2">{invoice?.primaryConsultantName}</div>
            </div>
          </div>
          <div>
            <div className="patient-info">
              <div className="subHeading">Receipt Date:</div>
              <div className="subHeading2">
                {" "}
                {moment(receiptDetails?.transactionDateTime).format(
                  "DD-MM-YYYY"
                )}{" "}
              </div>
            </div>
            <div className="patient-info">
              <div className="subHeading">Receipt Number:</div>
              <div className="subHeading2">{documentTitle}</div>
            </div>
          </div>
        </div>
        <div className="Thanks-text">
          Received with Thanks, an amount of Rs{" "}
          {receiptDetails?.transactionAmount?.toFixed(2)}, {receiptDetails?.advancePaymentName ? `from ${receiptDetails?.advancePaymentName}` : ''} towards Advance Payment via {receiptDetails?.modeOfPayment}.
        </div>

        <Table id="tablePreview" bordered hover>
          <thead style={{ backgroundColor: "#E1E3EF" }}>
            <tr>
              <th className='subHeading'>Receipt Id</th>
              <th className='subHeading'>Mode of Payment</th>
              <th className='subHeading'>Transaction Amount</th>
              <th className='subHeading'>Transaction Date & Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='subHeading2'>{receiptDetails?.mocReceiptId}</td>
              <td className='subHeading2'>{receiptDetails?.modeOfPayment}</td>
              <td className='subHeading2' style={{ textAlign: "left" }}>
                {receiptDetails?.transactionAmount?.toFixed(2)}
              </td>
              <td className='subHeading2'>
                {moment(receiptDetails?.transactionDateTime).format(
                  "DD-MM-YYYY"
                )}{" "}
                &nbsp; &nbsp;
                {moment(receiptDetails?.transactionDateTime).format(
                  "h:mm:ss a"
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  )
}

export default PrintAP
